import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as FileSaver from 'file-saver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXT = '.xlsx';

const font = { name: 'sans-serif', family: 2, size: 9, bold: true };
const analysisFont = {
  name: 'sans-serif',
  family: 4,
  size: 10,
  bold: true,
  underline: true,
};
const headerFont = { name: 'sans-serif', family: 4, size: 12, bold: true };
const nonBoldfont = { name: 'sans-serif', family: 2, size: 9, bold: false };
const centeralign = {
  vertical: 'middle',
  horizontal: 'center',
  wrapText: true,
};
const leftalign = { vertical: 'top', horizontal: 'left', wrapText: false };
const all_border = {
  top: { style: 'thin', color: { argb: 'FF000000' } },
  left: { style: 'thin', color: { argb: 'FF000000' } },
  bottom: { style: 'thin', color: { argb: 'FF000000' } },
  right: { style: 'thin', color: { argb: 'FF000000' } },
};
const no_border = {
  top: { style: 'thin', color: { argb: 'FF000000' } },
  left: { style: 'thin', color: { argb: 'FF000000' } },
  bottom: { style: 'thin', color: { argb: 'FF000000' } },
  right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
};
const totalBorderLess = {
  top: { style: 'hair', color: { argb: 'FFFFFFFF' } },
  left: { style: 'hair', color: { argb: 'FFFFFFFF' } },
  bottom: { style: 'hair', color: { argb: 'FFFFFFFF' } },
  right: { style: 'hair', color: { argb: 'FFFFFFFF' } },
};
const fill_color1 = {
  type: 'pattern',
  pattern: 'darkTrellis',
  fgColor: { argb: 'FFFFFFFF' },
  bgColor: { argb: 'FFFFFFFF' },
};
const fill_color2 = {
  type: 'pattern',
  pattern: 'darkTrellis',
  fgColor: { argb: 'FFFFFFFF' },
  bgColor: { argb: 'FFFFFFFF' },
};
const DynamiRowStart = 3;

@Injectable({
  providedIn: 'root',
})
export class ExportEmployerJobsService {
  constructor(public datepipe: DatePipe) {}
  //create range
  to_a(c1, c2) {
    let a = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    return a.slice(a.indexOf(c1), a.indexOf(c2) + 1);
  }

  //creating header for excel
  excelHeader(headerData) {
    return [
      {
        MERGE_CELL: 'A1:I1',
        CELL_NO: 'I1',
        CELL_VALUE: 'POSTED ALL JOBS ',
        CELL_FONT: analysisFont,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 0,
      },

      {
        MERGE_CELL: '',
        CELL_NO: 'A2',
        CELL_VALUE: 'SL No',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 6,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'B2',
        CELL_VALUE: 'VIEWS',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'C2',
        CELL_VALUE: 'APPLICATIONS',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'D2',
        CELL_VALUE: 'JOB TITLE',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'E2',
        CELL_VALUE: 'JOB TYPE',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'F2',
        CELL_VALUE: 'CHANNEL OF APPLICATON',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 25,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'G2',
        CELL_VALUE: 'POSTED ON',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 20,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'H2',
        CELL_VALUE: 'POSTED BY',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 20,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'I2',
        CELL_VALUE: 'STATUS',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 15,
      },
    ];
  }
  //creating header for excel
  excelHeaderCompanyBasic(headerData) {
    return [
      {
        MERGE_CELL: 'A1:H1',
        CELL_NO: 'H1',
        CELL_VALUE: 'POSTED ALL JOBS ',
        CELL_FONT: analysisFont,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 0,
      },

      {
        MERGE_CELL: '',
        CELL_NO: 'A2',
        CELL_VALUE: 'SL No',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 6,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'B2',
        CELL_VALUE: 'VIEWS',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'C2',
        CELL_VALUE: 'APPLICATIONS',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'D2',
        CELL_VALUE: 'JOB TITLE',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: '',
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'E2',
        CELL_VALUE: 'JOB TYPE',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 15,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'F2',
        CELL_VALUE: 'CHANNEL OF APPLICATON',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 25,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'G2',
        CELL_VALUE: 'POSTED ON',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 20,
      },
      {
        MERGE_CELL: '',
        CELL_NO: 'H2',
        CELL_VALUE: 'STATUS',
        CELL_FONT: font,
        CELL_ALIGN: centeralign,
        CELL_BORDER: all_border,
        CELL_FILL: fill_color1,
        CELL_WIDTH: 15,
      },
    ];
  }
  transformTreeDateTime(value = '', format = 'dd-MM-yyyy') {
    var datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, format);
    return value;
  }

  genExcel(data: any) {
    console.log(data);
    var workbook = new ExcelJS.Workbook();

    //generating range
    let fillColor1Cell = this.to_a('E', 'N');
    let fillColor2Cell = this.to_a('O', 'S');
    let fillColor3Cell = this.to_a('A', 'I');

    //get total number of record set
    let totalRecord = data.length;
    let headerColumns = this.excelHeader(data);
    let headerColumnsWidth = [];
    let rowDynamicData = [];

    //Set Workbook Properties
    // workbook.creator = 'Laboratory Information Management System - System Generated';
    workbook.lastModifiedBy = 'LIMS - System Generated';
    workbook.created = new Date();
    workbook.modified = new Date();

    // Force workbook calculation on load
    workbook.calcProperties.fullCalcOnLoad = true;

    // create a sheet with red tab colour
    var worksheet = workbook.addWorksheet('EMPLOYERS JOBS - ', {
      properties: { tabColor: { argb: 'FF8B008B' } },
    });
    worksheet.properties.defaultRowHeight = 25;

    headerColumns.forEach((item, index) => {
      //push all the widths for all column header cell
      if (item.CELL_WIDTH > 0) {
        headerColumnsWidth.push({ width: item.CELL_WIDTH });
      }

      //cell merge for column headers
      if (item.MERGE_CELL != '') {
        worksheet.mergeCells(item.MERGE_CELL);
      }
      // set the value for column headers
      worksheet.getCell(item.CELL_NO).value = item.CELL_VALUE;

      // set the alignment property for all column headers
      worksheet.getCell(item.CELL_NO).alignment = item.CELL_ALIGN;

      // set the fonts for all column headers
      worksheet.getCell(item.CELL_NO).font = item.CELL_FONT;

      // draw borders for for column headers
      worksheet.getCell(item.CELL_NO).border = item.CELL_BORDER;

      // fill the column headers by background color
      if (item.CELL_FILL != '') {
        worksheet.getCell(item.CELL_NO).fill = item.CELL_FILL;
      }
    });

    //set width for column headers
    worksheet.columns = headerColumnsWidth;

    data.forEach((rotate, index) => {
      rowDynamicData.push([
        index + 1,
        rotate.jobViewData.viewed,
        rotate.jobViewData.applied,
        rotate.title,
        rotate.job_type,
        rotate.apply_via == '1'
          ? 'apply on WorkNigeria'
          : rotate.apply_via == '2'
          ? 'apply on external'
          : 'apply via email',
        this.transformTreeDateTime(rotate.created_at),
        rotate.providerName,
        rotate.job_status,
      ]);
    });

    //set dynamic records
    worksheet.addRows(rowDynamicData);

    data.forEach((k, ind) => {
      // as initial 14 records are hide and for them no spl font, border or alignment is mentioned the styling is started from DynamiRowStart(14) no of rows
      worksheet.getRow(ind + DynamiRowStart).font = font;
      worksheet.getRow(ind + DynamiRowStart).alignment = centeralign;
      fillColor3Cell.forEach((c3, i) => {
        worksheet.getCell(c3 + (ind + DynamiRowStart)).border = all_border;
      });
    });

    let currentTime = new Date().getTime();

    workbook.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, 'Employers Posted Jobs' + EXCEL_EXT, true);
    });
  }

  genExcelCompanyBasic(data: any) {
    var workbook = new ExcelJS.Workbook();

    //generating range
    let fillColor1Cell = this.to_a('E', 'N');
    let fillColor2Cell = this.to_a('O', 'S');
    let fillColor3Cell = this.to_a('A', 'H');

    //get total number of record set
    let totalRecord = data.length;
    let headerColumns = this.excelHeaderCompanyBasic(data);
    let headerColumnsWidth = [];
    let rowDynamicData = [];

    //Set Workbook Properties
    // workbook.creator = 'Laboratory Information Management System - System Generated';
    workbook.lastModifiedBy = 'LIMS - System Generated';
    workbook.created = new Date();
    workbook.modified = new Date();

    // Force workbook calculation on load
    workbook.calcProperties.fullCalcOnLoad = true;

    // create a sheet with red tab colour
    var worksheet = workbook.addWorksheet('EMPLOYERS JOBS - ', {
      properties: { tabColor: { argb: 'FF8B008B' } },
    });
    worksheet.properties.defaultRowHeight = 25;

    headerColumns.forEach((item, index) => {
      //push all the widths for all column header cell
      if (item.CELL_WIDTH > 0) {
        headerColumnsWidth.push({ width: item.CELL_WIDTH });
      }

      //cell merge for column headers
      if (item.MERGE_CELL != '') {
        worksheet.mergeCells(item.MERGE_CELL);
      }
      // set the value for column headers
      worksheet.getCell(item.CELL_NO).value = item.CELL_VALUE;

      // set the alignment property for all column headers
      worksheet.getCell(item.CELL_NO).alignment = item.CELL_ALIGN;

      // set the fonts for all column headers
      worksheet.getCell(item.CELL_NO).font = item.CELL_FONT;

      // draw borders for for column headers
      worksheet.getCell(item.CELL_NO).border = item.CELL_BORDER;

      // fill the column headers by background color
      if (item.CELL_FILL != '') {
        worksheet.getCell(item.CELL_NO).fill = item.CELL_FILL;
      }
    });

    //set width for column headers
    worksheet.columns = headerColumnsWidth;

    data.forEach((rotate, index) => {
      rowDynamicData.push([
        index + 1,
        rotate.jobViewData.viewed,
        rotate.jobViewData.applied,
        rotate.title,
        rotate.job_type,
        rotate.apply_via == '1'
          ? 'apply on WorkNigeria'
          : rotate.apply_via == '2'
          ? 'apply on external'
          : 'apply via email',
        this.transformTreeDateTime(rotate.created_at),
        rotate.job_status,
      ]);
    });

    //set dynamic records
    worksheet.addRows(rowDynamicData);

    data.forEach((k, ind) => {
      // as initial 14 records are hide and for them no spl font, border or alignment is mentioned the styling is started from DynamiRowStart(14) no of rows
      worksheet.getRow(ind + DynamiRowStart).font = font;
      worksheet.getRow(ind + DynamiRowStart).alignment = centeralign;
      fillColor3Cell.forEach((c3, i) => {
        worksheet.getCell(c3 + (ind + DynamiRowStart)).border = all_border;
      });
    });

    let currentTime = new Date().getTime();

    workbook.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, 'Employers Posted Jobs' + EXCEL_EXT, true);
    });
  }
}
// }
